// src/journey/HalalvsharamInJourney.jsx
import React from "react";
import HalalvsharamJourneyView from "./HalalvsharamJourneyView";

function HalalvsharamInJourney({ questionsCount = 2, onComplete }) {
    return (
        <HalalvsharamJourneyView
            isJourney={true}
            gameLength={questionsCount}
            suppressBackground={true}
            onComplete={onComplete} // ✅ pass down
        />
    );
}

export default HalalvsharamInJourney;
